module.exports = __webpack_public_path__ + "static/img/iconfont.95959151.svg";